import { createContext, useContext } from "react";
import { StoreApi, useStore } from "zustand";
import { useShallow } from "zustand/react/shallow";

import { InteractiveTableStoreType } from "./interactive_table.store";

export const InteractiveTableStoreContext = createContext<StoreApi<InteractiveTableStoreType> | null>(null);

/**
 * Subscribe to a slice of the InteractiveTable store.
 * Returns null when called outside an InteractiveTable, so that components
 * such as TableCell can render normally without an interactive wrapper.
 */
export const useInteractiveTableStore = <U>(selector: (state: InteractiveTableStoreType) => U): U | null => {
  const store = useContext(InteractiveTableStoreContext);
  if (!store) {
    return null;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useStore<StoreApi<InteractiveTableStoreType>, U>(store, useShallow(selector));
};

export const useInteractiveTableActions = () => {
  const store = useContext(InteractiveTableStoreContext);
  if (!store) {
    throw new Error("useInteractiveTableActions must be used within an InteractiveTable");
  }

  return useStore(store, (state) => state.actions);
};
